import { create } from 'zustand';
import { adminCategoryManagementApi } from '@api/api-config';
import { AdminCategoryListResponse } from '@api/generated/portal-be-admin';

interface CategorySearchFilters {
  query?: string;
  /** Úroveň ve stromu kategorií, 5 = listy. */
  level?: number;
  page?: number;
  size?: number;
}

interface CategorySearchState {
  categories: AdminCategoryListResponse[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  isLoading: boolean;
  error: string | null;
}

interface CategorySearchActions {
  fetchCategories: (params?: CategorySearchFilters) => Promise<void>;
  clearError: () => void;
}

export const useCategorySearchStore = create<CategorySearchState & CategorySearchActions>((set, get) => ({
  categories: [],
  totalElements: 0,
  totalPages: 0,
  currentPage: 1,
  pageSize: 20,
  isLoading: false,
  error: null,

  fetchCategories: async (params = {}) => {
    set({ isLoading: true, error: null });

    try {
      const response = await adminCategoryManagementApi.getCategories({
        query: params.query,
        level: params.level,
        // Backend je 1-based (loadPageQuerydsl, `page <= 0` sanitizuje na 1) — neposílat page-1.
        page: params.page ?? 1,
        size: params.size ?? get().pageSize,
      });

      set({
        categories: response.data.items || [],
        totalElements: response.data.total || 0,
        totalPages: response.data.totalPages || 0,
        currentPage: response.data.page || 1,
        pageSize: response.data.size || 20,
        isLoading: false,
        error: null,
      });
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Nepodařilo se načíst kategorie';
      set({
        error: errorMessage,
        isLoading: false,
      });
    }
  },

  clearError: () => {
    set({ error: null });
  },
}));
